<template>
  <div class="footer__share">
    <BaseButton
      class="footer__share-button"
      variant="tertiary"
      rounded="full"
      width="small"
      aria-label="Visit Morrisons on Twitter"
    >
      <twitter-logo class="footer__share-logo" size="16"/>
    </BaseButton>
    <BaseButton
      class="footer__share-button"
      variant="tertiary"
      rounded="full"
      width="small"
      aria-label="Visit Morrisons on Facebook"
    >
      <facebook-logo class="footer__share-logo"/>
    </BaseButton>
    <BaseButton
      class="footer__share-button"
      variant="tertiary"
      rounded="full"
      width="small"
      aria-label="Visit Morrisons on LinkedIn"
    >
      <linkedin-logo class="footer__share-logo"/>
    </BaseButton>
    <BaseButton
      class="footer__share-button"
      variant="tertiary"
      rounded="full"
      width="small"
      aria-label="Visit Morrisons on Google+"
    >
      <google-logo class="footer__share-logo"/>
    </BaseButton>
    <BaseButton
      class="footer__share-button"
      variant="tertiary"
      rounded="full"
      width="small"
      aria-label="Write to us with email"
    >
      <BaseIcon name="email" size="20"></BaseIcon>
    </BaseButton>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import TwitterLogo from '@/assets/svg/logo-twitter.svg?inline'
import FacebookLogo from '@/assets/svg/logo-facebook.svg?inline'
import LinkedinLogo from '@/assets/svg/logo-linkedin.svg?inline'
import GoogleLogo from '@/assets/svg/logo-googleplus.svg?inline'

export default {
  name: 'ShareLinksFooter',
  components: {
    TwitterLogo,
    FacebookLogo,
    LinkedinLogo,
    GoogleLogo,
    BaseButton,
    BaseIcon
  }
}
</script>

<style lang="postcss">
.footer__share {
  @apply flex items-center;
}
.footer__share-logo {
  @apply w-4 h-4;
}
.footer__share-button {
  @apply text-white fill-current mx-2;
}
.article_share-button:last-of-type {
  @apply mb-0;
}
</style>